.backdrop {
  align-items: center;
  background-color: rgb(0 0 0 / 60%);
  display: flex;
  inset: 0;
  justify-content: center;
  position: fixed;
  z-index: 60;
}

.modal {
  background: var(--color-card, #fff);
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgb(0 0 0 / 10%);
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: 90vh;
  max-width: 720px;
  padding: 24px;
  width: 100%;
}

.header {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.title {
  color: var(--color-foreground, #18181b);
  font-size: 16px;
  font-weight: 600;
}

.close {
  background: transparent;
  border: 0;
  color: var(--color-muted-foreground, #71717a);
  cursor: pointer;
  font-size: 20px;
  padding: 4px;
}

.canvas {
  flex: 1;
  max-height: 60vh;
  overflow: auto;
}

.canvas img {
  max-height: 60vh;
  max-width: 100%;
}

.footer {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.btn {
  background: var(--color-card, #fff);
  border: 1px solid var(--color-border, #d4d4d8);
  border-radius: 6px;
  color: var(--color-foreground, #18181b);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
}

.btn-primary {
  background: var(--color-primary, #18181b);
  border-color: var(--color-primary, #18181b);
  color: var(--color-primary-foreground, #fff);
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
